import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-login" }
const _hoisted_2 = {
  style: {"height":"100vh","width":"100vw","max-width":"100%"},
  class: "flex justify-content-center align-items-center"
}
const _hoisted_3 = { class: "grid w-full" }
const _hoisted_4 = { class: "lg:col-4 lg:col-offset-4 md:col-8 md:col-offset-2 col-12" }
const _hoisted_5 = { class: "formgrid grid" }
const _hoisted_6 = { class: "col-12 field" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "col-12 field" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "col-8 p-fluid" }
const _hoisted_11 = { class: "col-4 p-fluid" }
const _hoisted_12 = { class: "col-12 my-2 flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" เข้าสู่ระบบ POD Admin ")
              ])),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { for: "username" }, "Username", -1)),
                    _createVNode(_component_InputText, {
                      id: "username",
                      modelValue: _ctx.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                      class: "inputfield w-full text-xl"
                    }, null, 8, ["modelValue"]),
                    (_ctx.v$.username.$error)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.username.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { for: "password" }, "Password", -1)),
                    _createVNode(_component_Password, {
                      id: "password",
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      class: "w-full",
                      inputClass: "inputfield w-full text-xl",
                      toggleMask: true
                    }, null, 8, ["modelValue"]),
                    (_ctx.v$.password.$error)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.v$.password.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-check",
                      label: "เข้าสู่ระบบ",
                      class: "p-button-success",
                      type: "submit"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-times",
                      label: "ยกเลิก",
                      class: "p-button-danger",
                      onClick: _ctx.onCancel
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Image, {
                      src: "https://www.haadthip.com/assets/images/logo.svg",
                      "image-style": "height:2rem"
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 32)
  ]))
}